import { SERVICES } from "@/data/portfolio";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="border-b border-white/10 py-10 md:py-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-6 md:mb-10">
          <h2 className="font-oswald uppercase text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95]">
            What we <span className="font-cormorant italic font-medium normal-case lowercase text-white/70">craft</span>
          </h2>
        </div>

        <div className="border-t border-white/10">
          {SERVICES.map((s, i) => (
            <div
              key={s.n}
              data-testid={`service-row-${i}`}
              className="group grid grid-cols-12 gap-6 items-start py-8 md:py-10 border-b border-white/10 hover:bg-white/[0.02] transition-colors px-2"
            >
              <div className="col-span-2 md:col-span-1 font-oswald text-2xl md:text-3xl text-white/30 group-hover:text-[#00A0E4] transition-colors">
                {s.n}
              </div>
              <div className="col-span-10 md:col-span-5">
                <h3 className="font-oswald uppercase text-2xl md:text-4xl font-semibold leading-tight">
                  {s.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-5 text-white/60 leading-relaxed text-sm md:text-base">
                {s.body}
              </div>
              <div className="hidden md:flex col-span-1 justify-end">
                <ArrowUpRight className="text-white/30 group-hover:text-[#00A0E4] transition-colors" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
